<template>
	<Modal title="Donations & Contributions" modal-width="full-width">
		<DisabledForm />

		<fieldset class="dt-responsive table-responsive">
			<legend>
				Contributions & Donations:
				<span style="font-size: 15px">
					(Include all Monetary and tangible non-monetary contributions and
					donations.)
				</span>
			</legend>

			<Alert />

			<table id="dt-live-domd" class="table table-bordered nowrap">
				<thead>
					<tr>
						<th>Name</th>
						<th>Address</th>
						<th>Occupation</th>
						<th>Type of <br />Contributor <br />(cash/in kind)</th>
						<th>Description of Contribution</th>
						<th>Value</th>
						<th>Total</th>
						<th>Action</th>
					</tr>
				</thead>
				<tbody>
					<template v-if="Object.keys(donations).length">
						<tr v-for="donation in donations" :key="'dn_' + donation.id">
							<td style="padding: 1.05rem 0.75rem">
								{{ donation.name }}
							</td>
							<td style="padding: 1.05rem 0.75rem">
								{{ donation.address }}
							</td>
							<td style="padding: 1.05rem 0.75rem">
								{{ donation.occupation }}
							</td>
							<td style="padding: 1.05rem 0.75rem">
								{{ donation.type_of_contribution }}
							</td>
							<td style="padding: 1.05rem 0.75rem">
								{{ donation.description }}
							</td>
							<td style="padding: 1.05rem 0.75rem">
								{{ donation.value }}
							</td>
							<td style="padding: 1.05rem 0.75rem">
								{{ donation.total }}
							</td>
							<td style="padding: 0">
								<button
									@click="deleteItem(donation)"
									class="btn btn-danger"
									style="border-radius: 0; height: 54px; width: 100%"
									:disable="isLoading"
								>
									<span
										v-if="isLoading"
										class="spinner-border spinner-border-sm"
										role="status"
									></span>
									<span v-else>Delete</span>
								</button>
							</td>
						</tr>
					</template>
					<tr>
						<td>
							<input
								v-model="form.name"
								type="text"
								class="form-control"
								autofocus
								placeholder="Start entering..."
							/>
						</td>
						<td>
							<input
								v-model="form.address"
								type="text"
								class="form-control"
								autofocus
								placeholder="Start entering..."
							/>
						</td>
						<td>
							<input
								v-model="form.occupation"
								type="text"
								class="form-control"
								autofocus
								placeholder="Start entering..."
							/>
						</td>
						<td>
							<select
								v-model="form.contribution_type"
								name=""
								id=""
								class="form-control"
							>
								<option value="">--select--</option>
								<option value="cash">Cash</option>
								<option value="in_kind">In-Kind</option>
							</select>
						</td>
						<td>
							<input
								v-model="form.description"
								type="text"
								class="form-control"
								autofocus
								placeholder="Start entering..."
							/>
						</td>
						<td>
							<input
								v-model="form.value"
								type="text"
								class="form-control"
								autofocus
								placeholder="Start entering..."
							/>
						</td>
						<td>
							<input
								v-model="form.total"
								type="text"
								class="form-control"
								autofocus
								placeholder="Start entering..."
							/>
						</td>

						<td style="padding: 0">
							<button
								@click="saveRecord()"
								class="btn btn-info"
								style="border-radius: 0; height: 100%; width: 100%"
								:disable="isLoading"
							>
								<span
									v-if="isLoading"
									class="spinner-border spinner-border-sm"
									role="status"
								></span>
								<span v-else>Save</span>
							</button>
						</td>
					</tr>
				</tbody>
			</table>
		</fieldset>
	</Modal>
</template>

<script>
import Modal from "@/components/Modal.vue";
import { EventBus } from "@/utils/event_bus.js";
import Alert from "@/components/Alert.vue";
import { mapActions, mapGetters } from "vuex";
import DisabledForm from "./DisabledForm.vue";
import Swal from "sweetalert2";

export default {
	components: {
		DisabledForm,
		Modal,
		Alert,
	},
	data() {
		return {
			approval_document_file_name: "",
			form: {
				report_id: this.$route.params.formID,
				report_type: "contributions_donations",
				report_from: "",
				report_to: "",
				approval_document: "",
				approved_by: "",
				name: "",
				address: "",
				occupation: "",
				contribution_type: "",
				description: "",
				value: "",
				total: "",
			},
		};
	},
	computed: {
		...mapGetters({
			isLoading: "shared/getLoading",
			donations: "form_ec16c/donations",
		}),
	},
	methods: {
		...mapActions({
			addForm: "form_ec16c/addForm",
			deleteFormRecord: "form_ec16c/deleteFormRecord",
			getFormDetails: "form_ec16c/getFormDetails",
		}),

		async saveRecord() {
			await this.addForm(this.form).then((res) => {
				if (res.status_code == 201) {
					this.clearFormInput();
				}
			});
		},

		clearFormInput() {
			this.form.name = "";
			this.form.address = "";
			this.form.occupation = "";
			this.form.contribution_type = "";
			this.form.description = "";
			this.form.value = "";
			this.form.total = "";
		},

		getFormItems() {
			let payload = {
				type: this.form.report_type,
				formID: this.$route.params.formID,
			};

			this.getFormDetails(payload);
		},

		deleteItem(item) {
			Swal.fire({
				title: "Delete Record?",
				text: "This action cannot be undone!",
				icon: "warning",
				showCancelButton: true,
				confirmButtonColor: "#d33",
				cancelButtonColor: "#29623c",
				confirmButtonText: "Yes, delete!",
				cancelButtonText: "Cancel",
			}).then((result) => {
				if (result.isConfirmed) {
					this.sendDeleteRequest(item);
				}
			});
		},

		async sendDeleteRequest(item) {
			let payload = {
				report_id: item.party_annual_report_id,
				item_id: item.id,
				report_type: item.report_type,
			};
			await this.deleteFormRecord(payload).then((res) => {
				if (res.status_code == 200) {
					Swal.fire("Deleted!", res.data.message, "success");
				}
			});
		},
	},

	mounted() {
		this.getFormItems();
		EventBus.$on("date-input", this.setDateInput);
		EventBus.$emit("toggle-modal", "show");
	},
};
</script>

<style scoped>
legend {
	background-color: #29623c;
	color: white;
	padding: 5px 10px;
}
.break-text {
	word-wrap: break-word;
	overflow-wrap: break-word;
	white-space: normal;
	padding: 0;
	padding-left: 2px;
	padding-top: 20px;
}
table {
	width: 100%;
	border-collapse: collapse;
}
td {
	/* height: 50px; */
	padding: 0;
}
td > input,
select {
	width: 100%;
	height: 100%;
	box-sizing: border-box;
	border: none;
	border-radius: 0;
	height: 100%;
}
.swal2-container {
	z-index: 1090 !important;
}

.modal {
	z-index: 1059 !important;
}
</style>
